export enum PoliceUnitTypes {
  SET_POLICE_UNIT = "SET_POLICE_UNIT",
  GET_POLICE_UNIT = "GET_POLICE_UNIT",
}
